import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// read-only popup: the guests of one booking, with the unmasked aadhaar the
// front desk uses to verify identity. data.guests comes straight from the
// check-in list row.
@Component({
  selector: 'app-guests-view-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './guests-view-dialog.component.html',
  styleUrls: ['./guests-view-dialog.component.scss', '../../../../common-style/ac-dialog.scss'],
})
export class GuestsViewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<GuestsViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      bookingId: number | string;
      familyCode: string | null;
      guests: Array<{
        fullName: string | null;
        aadhaarNumber: string | null;
        guestType: string | null;
        gender: string | null;
        relationship: string | null;
      }>;
    }
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
